'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _isArray = require('lodash/isArray');var _isArray2 = _interopRequireDefault(_isArray);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);

var _captchaService = require('../../helpers/captchaService');var _captchaService2 = _interopRequireDefault(_captchaService);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Helpers
var GoogleReCaptcha = function (_Component) {_inherits(GoogleReCaptcha, _Component);
  function GoogleReCaptcha(props) {_classCallCheck(this, GoogleReCaptcha);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.






























    copyElementToState = function (children) {
      if (!children) {return;}
      var severalChildren = (0, _isArray2.default)(children);
      var passed = severalChildren ? children[0] : children;
      var rest = severalChildren ? children.splice(1) : null;

      var element = _react2.default.createElement(passed.type, _extends({},
      passed.props, {
        onClick: function onClick(evt) {return _this.extendOnClick(evt, passed);} }));


      _this.setState({ element: element, severalChildren: severalChildren, rest: rest });
    };_this.

    initialize = function () {
      var widgetContainer = document.querySelector('#' + _this.state.captchaIdentifier);

      var captchaId = _this.recaptcha.render(
      widgetContainer,
      _this.captchaCallback,
      !_this.props.visible,
      _this.captchaErrorCallback,
      _this.captchaErrorCallback);


      _this.setState({ captchaId: captchaId });
    };_this.

    captchaCallback = function (resp) {
      _this.props.fetchToken(resp);
    };_this.

    captchaErrorCallback = function (resp) {
      _this.props.rejectCaptcha && _this.props.rejectCaptcha(resp);
    };_this.

    resetCaptcha = function () {
      if (_this.state.captchaId !== null) {
        _this.recaptcha.reset(_this.state.captchaId);
      }
    };_this.

    executeCaptcha = function () {
      if (_this.state.captchaId !== null) {
        _this.recaptcha.execute(_this.state.captchaId);
      }
    };_this.

    extendOnClick = function (evt, passed) {
      evt.preventDefault();

      if (passed.props.onClick && !_this.props.userAuthentication) {
        var recaptchaFailed = passed.props.onClick(evt);
        if (recaptchaFailed) {
          _this.executeCaptcha();
        }
      } else {
        _this.executeCaptcha();
      }
    };_this.state = { captchaIdentifier: props.captchaIdentifier || 'recaptchaElement', captchaId: null, element: null, rest: null };return _this;}GoogleReCaptcha.prototype.componentWillMount = function componentWillMount() {this.copyElementToState(this.props.children);};GoogleReCaptcha.prototype.componentDidMount = function componentDidMount() {var _this2 = this;new _captchaService2.default(this.props.locale, function (recaptcha) {// eslint-disable-line no-new
      _this2.recaptcha = recaptcha;_this2.initialize();});};GoogleReCaptcha.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {var doReset = _ref.doReset,children = _ref.children;if (doReset && doReset !== this.props.doReset) {this.resetCaptcha();}if (children && !(0, _isEqual2.default)(children, this.props.children)) {this.copyElementToState(children);}};GoogleReCaptcha.prototype.
  render = function render() {
    return (
      _react2.default.createElement('div', null,
        this.state.element,
        this.state.rest,
        _react2.default.createElement('div', { id: this.state.captchaIdentifier })));


  };return GoogleReCaptcha;}(_react.Component);exports.default = GoogleReCaptcha;


GoogleReCaptcha.propTypes = {
  locale: _propTypes2.default.string,
  fetchToken: _propTypes2.default.func,
  rejectCaptcha: _propTypes2.default.func,
  doReset: _propTypes2.default.bool,
  children: _propTypes2.default.any,
  visible: _propTypes2.default.bool,
  userAuthentication: _propTypes2.default.bool,
  captchaIdentifier: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GoogleReCaptcha/GoogleReCaptcha.js
// module id = 2696
// module chunks = 0